export default __webpack_public_path__ + "static/media/tensor-flow.2aad4568.jpg";